import React, { useEffect } from 'react'
import { getStripe } from '../stripe';

export default function StripeCardField({cardElement, onCardElement}) {


  const style = {
    base: {
      color: '#2b2b2b',
      fontFamily: '"Locator Regular", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '15px',
      '::placeholder': {
        color: '#c3c3c1'
      },
      padding: '12px 8px'
    },
    invalid: {
      color: '#bb0022',
      iconColor: '#bb0022'
    }
  };

  useEffect(() => {
    getStripe().then(stripe => {
      const elements = stripe.elements();
      const _cardElement = cardElement || elements.create('card', {style: style});
      _cardElement.mount(document.getElementById('stripe-form-card-element'));
      onCardElement(_cardElement);
    })
  }, []);

  return <div id='stripe-form-card-element' className='card-element'></div>

}